import { Spinner } from "react-bootstrap";
import { createPortal } from "react-dom";

/** Above Bootstrap modal (1055) / backdrop so loaders always cover open modals. */
const LOADER_Z_INDEX = 20000;

const Loader = () => {
    const content = (
        <div
            className="d-flex align-items-center justify-content-center w-100 h-100 globalAppLoader"
            style={{
                position: "fixed",
                inset: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.45)",
                zIndex: LOADER_Z_INDEX,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "24px 24px 22px",
                    borderRadius: "6px",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
            >
                <Spinner animation="border" role="status" />
            </div>
        </div>
    );

    if (typeof document === "undefined") return content;
    return createPortal(content, document.body);
};

export default Loader;
